import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { removeMessage, setAutoRemoveMessage } from '../../redux/common/alert-slice';

import './../../styles/toaster.css';

const icons = {
    success: [
        'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z'
    ],
    warning: [
        'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z'
    ],
    info: [
        'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z'
    ],
    error: [
        'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z'
    ]
};

const iconFill = {
    success: "rgb(49 196 141)",
    warning: "rgb(255 138 76)",
    info: "rgb(164 202 254)",
    error: "rgb(249 128 128)",
    default: "currentColor"
};

const MessageToaster = () => {
    // Select message from redux store
    const dispatch = useDispatch();
    const { messages } = useSelector(state => state.alert);

    // Function to handle remove message on close button
    const removeToast = useCallback((id) => {
        dispatch(removeMessage({ id: id }))
    }, [dispatch]);

    useEffect(() => {
        // Function to handle auto hide message after 3 second
        if (messages.length > 0) {
            const timer = setTimeout(() => {
                dispatch(setAutoRemoveMessage());
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [messages, dispatch]);

    return (
        <div className='toaster w-full max-w-sm sm:w-3/5 md:w-2/5 lg:w-1/3 overflow-y-auto'>
            {messages.map((toast, index) => (
                <div key={index} className={`toast ${toast.type}`}>
                    <svg className='w-5 h-5' aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill={iconFill[toast.type]} viewBox='0 0 20 20'>
                        <path d={icons[toast.type]} />
                    </svg>
                    <div className='flex-1'>
                        <h6 className='font-semibold'>{toast.text}</h6>
                        {toast.details && (
                            <div className='mt-1 text-sm opacity-90 whitespace-pre-line'>
                                {toast.details}
                            </div>
                        )}
                    </div>
                    {/* <button type='button' className={toast.type} onClick={() => removeToast(index)}>
                        <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 14 14'>
                            <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6' />
                        </svg>
                    </button> */}
                </div>
            ))}
        </div>
    )
};

export default MessageToaster;